import { LastUserReviewResponse, useGetLastRequestCompliance } from '@ping/api';
import FileIcon from '@ping/assets/Icon/file.svg';
import { ProvideRequestedDocumentsModal } from '@ping/components';
import { t } from '@ping/helpers';
import { KycCardContactUsSection } from '../KycCardContactSection';
import { KycCardLayout } from '../KycCard/KycCardLayout';
import style from './style.module.scss';

export const RequestedDocumentsCard = () => {
  const { data: lastRequest } = useGetLastRequestCompliance<LastUserReviewResponse>();

  return (
    <KycCardLayout
      headerTitle={t('More documents required')}
      HeaderIcon={<FileIcon />}
      className={style['requested-documents-card']}
    >
      <div className={style['requested-documents']}>
        <div className={style['requested-documents__left-side']}>
          <h6 className={style['requested-documents__title']}>{t('Additional documents requested')}</h6>
          <p className={style['requested-documents__description']}>
            {t('Our compliance team has requested additional documents to continue your account verification.')}
          </p>
          {lastRequest?.comment && <p className={style['requested-documents__comment']}>{lastRequest.comment}</p>}
          <ProvideRequestedDocumentsModal.Trigger />
        </div>
        <KycCardContactUsSection />
      </div>
    </KycCardLayout>
  );
};
